import { useState } from "react";
import { Button, Input, Select } from "../../../ui";
import { hasValidSarPrecision, sarToMinorUnits } from "../../../../utils/billingMoney";

// One small form for every manual wallet action (adjust, refund, reverse,
// freeze, resolve an unknown cost). Each action is a compensating ledger
// entry and needs a reason; the server validates and authorizes everything.
//
//   fields: { direction, amount, allowPartial, cost, note } - which inputs to show
//   onSubmit({ direction, amountMinor, reason, allowPartial, cost, note })
const AiWalletActionModal = ({ title, description, fields = {}, text, lang, onSubmit, onCancel, maxMinor = null }) => {
  const t = text.admin;
  const [direction, setDirection] = useState("credit");
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const [allowPartial, setAllowPartial] = useState(false);
  const [cost, setCost] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const amountOk = !fields.amount || (hasValidSarPrecision(amount) && sarToMinorUnits(amount) > 0 && (maxMinor === null || sarToMinorUnits(amount) <= maxMinor));
  const canSubmit = amountOk && (fields.note || reason.trim().length > 0) && (!fields.cost || /^\d+(\.\d{1,9})?$/.test(cost.trim()));

  const submit = async () => {
    if (submitting || !canSubmit) return;
    setSubmitting(true);
    setError("");
    try {
      await onSubmit({ direction, amountMinor: fields.amount ? sarToMinorUnits(amount) : undefined, reason: reason.trim(), allowPartial, cost: cost.trim(), note: reason.trim() });
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <div className="billing-modal-backdrop" dir={lang === "en" ? "ltr" : "rtl"}>
      <div className="billing-modal aiw-modal" role="dialog" aria-modal="true" aria-label={title}>
        <h3>{title}</h3>
        {description && <p>{description}</p>}
        {error && <div className="billing-error">{error}</div>}
        {fields.direction && <Select label={t.direction} value={direction} onChange={(event) => setDirection(event.target.value)} options={[{ value: "credit", label: t.directions.credit }, { value: "debit", label: t.directions.debit }]} />}
        {fields.amount && <Input label={t.amountSar} inputMode="decimal" value={amount} onChange={(event) => setAmount(event.target.value.trim())} placeholder="0.00" error={amount && !amountOk ? true : undefined} />}
        {fields.cost && <Input label={t.confirmedCost} inputMode="decimal" value={cost} onChange={(event) => setCost(event.target.value)} placeholder="0.0000" />}
        <Input textarea label={fields.note ? t.note : t.reason} value={reason} onChange={(event) => setReason(event.target.value)} />
        {fields.allowPartial && (
          <label className="aiw-check">
            <input type="checkbox" checked={allowPartial} onChange={(event) => setAllowPartial(event.target.checked)} />
            {t.allowPartial}
          </label>
        )}
        <div className="billing-modal-actions">
          <Button appearance="filled" loading={submitting} disabled={submitting || !canSubmit} onClick={submit}>
            {t.confirm}
          </Button>
          <Button appearance="ghost" disabled={submitting} onClick={onCancel}>
            {text.cancel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AiWalletActionModal;
